import {
  ControlcenterMelcoModelsSerialNumberListItem,
  LicensesApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
//import { ALL_ORDER_SESSION_STATUS, OrderProductionStatus, OrderSessionStatus } from "../../helper/licencesHelper";
import { LicencesListFiltersType } from "./LicencesListFiltersType";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useLicences = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<
    ControlcenterMelcoModelsSerialNumberListItem,
    LicencesListFiltersType
  >({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();

  const query = useAPIQuery(
    LicensesApi,
    ["licences", currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new SystemManagementApi(baseApiConfig({ token }));
      //console.log({filters, currentPage, pageSize})
      let response;
      //   if(filters?.Products) {
      response = await api.searchSerialNumber({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        productCodes:
          filters?.products && !isEmpty(filters.products)
            ? filters.products
            : "",
        subscriptionCode:
          filters?.subscriptionLevel && !isEmpty(filters.subscriptionLevel)
            ? filters.subscriptionLevel
            : "",
        referralCode:
          filters?.refferal && !isEmpty(filters.refferal)
            ? filters.refferal
            : "",
        batch:
          filters?.batchNumber && !isEmpty(filters.batchNumber)
            ? filters.batchNumber
            : "",
        // cancelled:
        //   filters?.state && !isEmpty(filters.state)
        //     ? filters.state
        //     : 'false',
        serialNumber:
          filters?.serialNumber && !isEmpty(filters.serialNumber)
            ? filters.serialNumber
            : "",
        userName: filters?.userName && !isEmpty(filters.userName)
          ? filters?.userName
          : "",
        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters?.searchText
            : "",
        versionId:
          filters?.versionId && !isEmpty(filters.versionId)
            ? filters?.versionId
            : "",
        typeList:
          filters?.typeList && !isEmpty(filters.typeList)
            ? filters.typeList.join(",")
            : undefined,
      });
      //}

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
